import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ContentLayoutService {
  public isSidebarOpen$ = new Subject<boolean>();

  constructor(
  ) { }

  setSidebarOpen(open: boolean) {
    this.isSidebarOpen$.next(open);
  }

  getSidebarOpen(): Observable<any> {
    return this.isSidebarOpen$.asObservable();
  }
}
